/**
 * @generated SignedSource<<75bbd01bb3a51da33f5c93381666dc77>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionLeaderboardPageQuery$variables = {
  slug: string;
  stage?: number | null | undefined;
};
export type CompetitionLeaderboardPageQuery$data = {
  readonly competitionBySlug: {
    readonly id: string;
    readonly membership: {
      readonly asEntity: {
        readonly " $fragmentSpreads": FragmentRefs<"CompetitionEntitySubmissionStatusEntityFragment">;
      };
      readonly id: string;
    } | null | undefined;
    readonly slug: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionEntitySubmissionStatusCompetitionFragment" | "CompetitionLeaderboardFragment" | "CompetitionStageSelectFragment" | "SubjectSubscriptionButtonFragment">;
  } | null | undefined;
};
export type CompetitionLeaderboardPageQuery = {
  response: CompetitionLeaderboardPageQuery$data;
  variables: CompetitionLeaderboardPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stage"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "stage",
    "variableName": "stage"
  }
],
v6 = {
  "kind": "Literal",
  "name": "hasLeaderboard",
  "value": true
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v11 = [
  (v10/*:: as any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "score",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seq",
  "storageKey": null
},
v16 = [
  (v10/*:: as any*/),
  (v6/*:: as any*/)
],
v17 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "version",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ProjectVersionEvaluation",
    "kind": "LinkedField",
    "name": "evaluation",
    "plural": false,
    "selections": [
      (v13/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "finalizedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "max",
        "storageKey": null
      },
      (v2/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "project",
    "plural": false,
    "selections": [
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "CompetitionStage",
        "kind": "LinkedField",
        "name": "stage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showMetric",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "noCode",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      },
      (v2/*:: as any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionLeaderboardPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionMembership",
            "kind": "LinkedField",
            "name": "membership",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asEntity",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "CompetitionEntitySubmissionStatusEntityFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "args": (v5/*:: as any*/),
            "kind": "FragmentSpread",
            "name": "CompetitionLeaderboardFragment"
          },
          {
            "args": [
              (v6/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "CompetitionStageSelectFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CompetitionEntitySubmissionStatusCompetitionFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SubjectSubscriptionButtonFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "CompetitionLeaderboardPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Competition",
        "kind": "LinkedField",
        "name": "competitionBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionMembership",
            "kind": "LinkedField",
            "name": "membership",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asEntity",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  (v8/*:: as any*/),
                  (v2/*:: as any*/),
                  (v9/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "CompetitionStage",
            "kind": "LinkedField",
            "name": "stage",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasLeaderboard",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v11/*:: as any*/),
                "concreteType": "SubmissionRankingConnection",
                "kind": "LinkedField",
                "name": "leaderboard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubmissionRankingSubmissionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validatedAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Submission",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "entity",
                            "plural": false,
                            "selections": [
                              (v7/*:: as any*/),
                              (v2/*:: as any*/),
                              (v9/*:: as any*/),
                              (v8/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "displayName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "imageThumbnail",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*:: as any*/),
                          (v7/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v14/*:: as any*/)
                ],
                "storageKey": "leaderboard(first:10)"
              },
              {
                "alias": null,
                "args": (v11/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "CompetitionLeaderboardFragment_leaderboard",
                "kind": "LinkedHandle",
                "name": "leaderboard"
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionStage",
            "kind": "LinkedField",
            "name": "currentStage",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v15/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v16/*:: as any*/),
            "concreteType": "CompetitionStageConnection",
            "kind": "LinkedField",
            "name": "stages",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CompetitionStageEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionStage",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      (v15/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "validUntil",
                        "storageKey": null
                      },
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v12/*:: as any*/)
                ],
                "storageKey": null
              },
              (v14/*:: as any*/)
            ],
            "storageKey": "stages(first:10,hasLeaderboard:true)"
          },
          {
            "alias": null,
            "args": (v16/*:: as any*/),
            "filters": [
              "hasLeaderboard",
              "requiresApproval"
            ],
            "handle": "connection",
            "key": "CompetitionStageSelectFragment_stages",
            "kind": "LinkedHandle",
            "name": "stages"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Submission",
            "kind": "LinkedField",
            "name": "submission",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectVersion",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": (v17/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectVersionEvaluation",
                "kind": "LinkedField",
                "name": "maxEvaluation",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProjectVersion",
                    "kind": "LinkedField",
                    "name": "projectVersion",
                    "plural": false,
                    "selections": (v17/*:: as any*/),
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "viewerCanSubscribe",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "CREATE_SUBJECT_SUBSCRIPTION"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"CREATE_SUBJECT_SUBSCRIPTION\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entitySubscription",
                "plural": false,
                "selections": [
                  (v7/*:: as any*/),
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "kind",
                    "storageKey": null
                  },
                  {
                    "alias": "viewerCanUnsubscribe",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "DELETE_SUBJECT_SUBSCRIPTION"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"DELETE_SUBJECT_SUBSCRIPTION\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Subscribable",
            "abstractKey": "__isSubscribable"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "083a99f33a8cc3db55a2725c074b8940",
    "id": null,
    "metadata": {},
    "name": "CompetitionLeaderboardPageQuery",
    "operationKind": "query",
    "text": "query CompetitionLeaderboardPageQuery(\n  $slug: String!\n  $stage: Int\n) {\n  competitionBySlug(slug: $slug) {\n    id\n    membership {\n      id\n      asEntity {\n        __typename\n        ...CompetitionEntitySubmissionStatusEntityFragment\n        id\n      }\n    }\n    title\n    slug\n    ...CompetitionLeaderboardFragment_YHaL6\n    ...CompetitionStageSelectFragment_1LLlkW\n    ...CompetitionEntitySubmissionStatusCompetitionFragment\n    ...SubjectSubscriptionButtonFragment\n  }\n}\n\nfragment CompetitionEntitySubmissionStatusCompetitionFragment on Competition {\n  id\n  slug\n  submission @ifAllowed {\n    id\n    latest {\n      id\n      version\n      ...SubmissionStatusBadgeFragment\n    }\n    maxEvaluation {\n      projectVersion {\n        id\n        version\n        ...SubmissionStatusBadgeFragment\n      }\n      id\n    }\n  }\n}\n\nfragment CompetitionEntitySubmissionStatusEntityFragment on Entity {\n  __isEntity: __typename\n  id\n  username\n}\n\nfragment CompetitionLeaderboardFragment_YHaL6 on Competition {\n  stage(stage: $stage) {\n    hasLeaderboard\n    leaderboard(first: 10) {\n      edges {\n        cursor\n        score\n        validatedAt\n        node {\n          entity {\n            __typename\n            id\n            username\n            ...EntityProfilePicFragment_49kWkb\n          }\n          id\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  id\n}\n\nfragment CompetitionStageSelectFragment_1LLlkW on Competition {\n  currentStage {\n    id\n    seq\n  }\n  stages(first: 10, hasLeaderboard: true) {\n    edges {\n      node {\n        id\n        seq\n        validUntil\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment SubjectSubscriptionButtonFragment on Subscribable {\n  __isSubscribable: __typename\n  id\n  viewerCanSubscribe: viewerCan(action: CREATE_SUBJECT_SUBSCRIPTION)\n  entitySubscription @ifAllowed {\n    __typename\n    id\n    kind\n    viewerCanUnsubscribe: viewerCan(action: DELETE_SUBJECT_SUBSCRIPTION)\n  }\n}\n\nfragment SubmissionStatusBadgeFragment on ProjectVersion {\n  id\n  status\n  version\n  evaluation {\n    score\n    error\n    finalizedAt\n    max\n    id\n  }\n  project {\n    __typename\n    stage {\n      showMetric\n      noCode\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "afe754d984c96a3d4be5ab2a137b0af8";

export default node;
